<template>
    <form>
        <div>
            <b-alert
                    variant="success"
                    :show="message != null && message.length > 0"
                    dismissible>
                {{message}}
            </b-alert>
            <div class="alert alert-danger" v-show="error">{{'revisions.error_ocurred_try_again_later' | trans}}</div>
            <div v-if="initialized && entry">

                <inner-form
                        :categories="categories"
                        :months="months"
                        :quarters="quarters"
                        :halfYears="halfYears"
                        :years="years"
                        :form="form"
                        :previousRevision="previousRevision"
                        :error="error"
                        :errorGeoCode="errorGeoCode"></inner-form>


                <div class="mb-4 card-text">
                    <b-card :title="'revisions.comments' | trans">
                        <ul class="pl-0">
                            <li style="list-style: none;" class="mb-1" v-for="comment in form.comments"
                                v-bind:key="comment.id">
                                {{comment.user.name}} {{comment.as_moderator ? '(Moderator)' : ''}}: {{comment.comment}}
                                <div style="font-size: 10px; color: lightgray;">{{formatDate(comment.created_at)}}</div>
                            </li>
                        </ul>
                        <hr>
                        <b-form-group
                                :label="'revisions.comment' | trans"
                                label-for="comment"
                                :invalid-feedback="form.errors.gets('comment')"
                                :state="form.errors.getState('comment')">
                            <b-textarea
                                    id="comment"
                                    v-model="form.comment"
                                    :state="form.errors.getState('comment')"
                                    :rows="3"
                            ></b-textarea>
                        </b-form-group>
                    </b-card>
                    <div v-if="platform === 'neueroeffnung'">
                        <b-card class="mt-1">
                            Ablehnungsgrund auswählen (wird in Kommentarfeld eingetragen)
                            <hr>
                            <b-form-select v-model="selectedReason" @change="updateComment">
                                <option value="">Ablehnungsgrund auswählen</option>
                                <option value="Die Quelle lässt sich nicht öffnen – bitte prüfen">Die Quelle lässt sich nicht öffnen – bitte prüfen</option>
                                <option value="Bitte einen Direktlink mit dem Datum der Neueröffnung einreichen">Bitte einen Direktlink mit dem Datum der Neueröffnung einreichen</option>
                                <option value="Bitte eine nachvollziehbare Quelle angeben oder einen Screenshot an redaktion@neueroeffnung.info senden">Bitte eine nachvollziehbare Quelle angeben oder einen Screenshot an redaktion@neueroeffnung.info senden</option>
                                <option value="Bitte einen vollständigen Satz in die Beschreibung schreiben">Bitte einen vollständigen Satz in die Beschreibung schreiben</option>
                                <option value="Bitte auf Groß-Kleinschreibung und Grammatik achten">Bitte auf Groß-Kleinschreibung und Grammatik achten</option>
                            </b-form-select>
                        </b-card>
                    </div>
                </div>
                <div class="mb-4">
                    <a v-if="entry.user_id" :href="`/moderation/moderate/${entry.user_id}`" target="_blank" class="btn btn-dark">
                        {{'revisions.open_entries_of_user' | trans}}
                    </a>
                    <b-button variant="info" @click.prevent.stop="acceptBlockRevision" :disabled="this.isSending">{{'revisions.acceptblock' | trans}}
                    </b-button>
                    <b-button variant="primary" @click.prevent.stop="skipRevision" :disabled="this.isSending">{{'revisions.skip' | trans}}
                    </b-button>
                    <b-button variant="success" @click.prevent.stop="acceptRevision" :disabled="this.isSending">{{'revisions.accept' | trans}}
                    </b-button>
                    <b-button variant="danger" @click.prevent.stop="blockRevision" :disabled="this.isSending">{{'revisions.block' | trans}}
                    </b-button>
                </div>
                <div class="mb-4">
                    <duplicates :duplicates="duplicates" :is-loading="isLoadingDuplicates"></duplicates>
                </div>
              <div v-if="platform === 'neueroeffnung'" class="alert alert-info">Noch {{ this.revisionCount | pluralize('weiterer Eintrag in der Warteschleife.','weitere Einträge in der Warteschleife.') }}</div>
              <div v-if="platform === 'openings24'" class="alert alert-info">{{ this.revisionCount | pluralize('more entry in the queue.','more entries in the queue.') }}</div>
            </div>
            <div v-else-if="initialized === true && error === null">
                <b-alert variant="danger" show>{{'revisions.no_entry_to_moderate' | trans}}</b-alert>
            </div>
            <div v-else-if="error === null">
                <div class="d-flex flex-column justify-content-center" style="min-height: 150px;">
                    <div class="d-flex flex-row justify-content-center">
                        <div class="col">
                            <b-progress :value="100" show-progress animated height="20px"></b-progress>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</template>

<script>
    import Form from "../helper/form";
    import Errors from "../helper/errors";
    import _ from "lodash";

    let moment = require("moment");

    export default {
        props: {
            categories: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            months: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            quarters: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            halfYears: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            years: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            isLoadingDuplicates: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            platform:
                {
                  type: String,
                  default: function () {
                    return (process.env.MIX_PLATFORM);
                  }
                },
        },
        data: function () {
            return {
                selectedReason: '',
                initialized: false,
                entry: null,
                form: new Form({}, new Errors({})),
                geocoder: null,
                previousRevision: {},
                message: null,
                error: null,
                errorGeoCode: false,
                duplicates: [],
                isSending: false,
                revisionCount: null
            };
        },
        created: function () {
          this.$gmapApiPromiseLazy().then(() => {
            this.geocoder = new google.maps.Geocoder();
          });
        },
        mounted: function () {
            this.getNext();
        },
        watch: {
            "form.street": function (val) {
                this.geocodeAddress(
                    val +
                    " " +
                    this.form.street_number +
                    ", " +
                    this.form.postal_code +
                    " " +
                    this.form.city
                );
            },
            "form.street_number": function (val) {
                this.geocodeAddress(
                    this.form.street +
                    " " +
                    val +
                    ", " +
                    this.form.postal_code +
                    " " +
                    this.form.city
                );
            },
            "form.postal_code": function (val) {
                this.geocodeAddress(
                    this.form.street +
                    " " +
                    this.form.street_number +
                    ", " +
                    val +
                    " " +
                    this.form.city
                );
            },
            "form.city": function (val) {
                this.geocodeAddress(
                    this.form.street +
                    " " +
                    this.form.street_number +
                    ", " +
                    this.form.postal_code +
                    " " +
                    val
                );
            },
            "form.title": function () {
                this.checkDuplicates();
            }
        },
        methods: {
            formatDate(date) {
                return moment(date).format("DD.MM.YYYY hh:mm");
            },
            checkDuplicates: _.debounce(function () {
                this.$emit("duplicates-loading", true);
                this.form
                    .checkDuplicates("post", "/entries/duplicates")
                    .then(response => {
                        this.duplicates = response;
                        this.$emit("duplicates-loading", false);
                        this.$emit("duplicates-change", this.duplicates);
                    })
                    .catch(response => {
                        this.$emit("duplicates-loading", false);
                    });
            }, 1000),
            geocodeAddress: _.debounce(function (address) {
                this.geocoder.geocode(
                    {address: address},
                    function (results, status) {
                        if (status === "OK") {
                            this.form.lat = results[0].geometry.location.lat();
                            this.form.lng = results[0].geometry.location.lng();
                            this.errorGeoCode = null;
                        } else {
                            this.form.lat = 0;
                            this.form.lng = 0;
                            this.errorGeoCode = true;
                        }
                        this.checkDuplicates();
                    }.bind(this)
                );
            }, 500),
            clearMessages: function () {
                this.error = null;
            },
            skipRevision: function () {
                this.isSending = true;
                this.clearMessages();
                let id = this.entry.id;
                this.initialized = false;
                this.entry = null;
                this.form = new Form({}, new Errors({}));
                window.scrollTo(0, 0);
                axios
                    .get("/moderation/skip/" + id)
                    .then(response => {
                        this.entry = response.data.formData.revision;
                        this.form = new Form(response.data.formData.revision, new Errors({}));
                        this.previousRevision = response.data.formData.previousRevision;
                        this.initialized = true;
                        window.scrollTo(0, 0);
                        this.isSending = false;
                    })
                    .catch(error => {
                        if (error.response.status === 422) this.initialized = true;
                        else this.error = 1;
                        this.isSending = false;
                    });
            },
            acceptBlockRevision: function () {
                this.isSending = true;
                this.clearMessages();
                let id = this.entry.id;
                this.form
                    .post("/moderation/acceptblock/"+ id, true)
                    .then(response => {
                        this.message = response.message;
                        this.initialized = false;
                        this.getNext();
                        this.isSending = false;
                    })
                    .catch(response => {
                        if (response === false) this.error = 1;
                        window.scrollTo(0, 0);
                        this.isSending = false;
                    });
            },
            getNext: function () {
                this.clearMessages();
                this.initialized = false;
                this.entry = null;
                this.form = new Form({}, new Errors({}));
                axios
                    .get("/moderation/moderate_next")
                    .then(response => {
                        this.entry = response.data.formData.revision;
                        this.form = new Form(response.data.formData.revision, new Errors({}));
                        this.previousRevision = response.data.formData.previousRevision;
                        this.revisionCount = response.data.revisionCount;
                        this.initialized = true;
                        window.scrollTo(0, 0);
                        this.isSending = false;
                    })
                    .catch(error => {
                        if (error.response.status === 422) this.initialized = true;
                        else this.error = 1;
                        window.scrollTo(0, 0);
                        this.isSending = false;
                    });
            },
            acceptRevision: function () {
                this.isSending = true;
                this.clearMessages();
                this.form
                    .post("/moderation/accept", true)
                    .then(response => {
                        this.message = response.message;
                        this.initialized = false;
                        this.getNext();
                        this.isSending = false;
                    })
                    .catch(response => {
                        if (response === false) this.error = 1;
                        window.scrollTo(0, 0);
                        this.isSending = false;
                    });
            },
            blockRevision: function () {
                this.isSending = true;
                this.clearMessages();
                let id = this.entry.id;
                this.form
                    .post("/moderation/block/" + id, true)
                    .then(response => {
                        this.message = response.message;
                        var self = this;
                        setTimeout(function () {
                            self.message = "";
                        }, 2000);
                        this.initialized = false;
                        this.getNext();
                        this.isSending = false;
                    })
                    .catch(response => {
                        if (response === false) this.error = 1;
                        window.scrollTo(0, 0);
                        this.isSending = false;
                    });
            },
            onTabSelected: function (tabIndex) {
                // tabIndex starts with 0 so add 1
                this.form.time_period = tabIndex + 1;
            },
            updateComment: function() {
                this.form.comment = this.selectedReason;
            }
        },
      filters: {
        pluralize: function (count, sing, plur) {
          if (count === 1) {
            return count + ` ${sing}`;
          } else if (count > 1) {
            return count + ` ${plur}`;
          } else {
            return "Please pass valid count of data.";
          }
        },
      },
    };
</script>

